import {Component, HostBinding, Input, ViewChild} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {IonInput} from '@ionic/angular';

@Component({
    selector: 'app-input',
    template: `
        <ion-label position="stacked" color="dark"
                   class="monospaced ion-margin-top">{{ label }}
            @if (!_control.untouched && _control.invalid) {
                <ion-text color="danger">
                    {{ errorText }}
                </ion-text>
            }
        </ion-label>
        <ion-input #input
                   trim
                   inputmode="text"
                   [ngClass]="cssClass"
                   [required]="required"
                   [pattern]="pattern"
                   [minlength]="minlength"
                   [maxlength]="maxlength"
                   [type]="type"
                   [formControl]="_control"
                   [clearInput]="clearInput"
                   [placeholder]="placeholder">
        </ion-input>
    `,
    standalone: false
})
export class InputComponent {
    @HostBinding('class') classes = 'w-100';

    @ViewChild('input') input!: IonInput;
    _control: FormControl;

    @Input()
    public set control(control: AbstractControl) {
        this._control = control as FormControl;
    }

    @Input()
    public label: string;

    @Input()
    public type: string;

    @Input()
    public errorText: string;

    @Input()
    public clearInput: boolean;

    @Input()
    public required: boolean;

    @Input()
    public pattern: string;

    @Input()
    public minlength: number;

    @Input()
    public maxlength: number;

    @Input()
    public placeholder: string | null | undefined;

    @Input()
    public cssClass: string;

    public setFocus(): Promise<void> {
        return this.input.setFocus();
    }
}
